import React from "react"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => <>{element}</>
